(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.mennaQuantityInit) {
    window.mennaQuantityInit = true;

    document.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-qty-btn]');
      if (!btn) return;

      const wrapper = btn.closest('.product-card__qty-wrapper');
      if (!wrapper) return;

      const input = wrapper.querySelector('.product-card__qty-input');
      if (!input) return;

      let value = parseInt(input.value || '1', 10);

      if (btn.dataset.qtyBtn === 'minus') {
        value = Math.max(1, value - 1);
      } else if (btn.dataset.qtyBtn === 'plus') {
        value = value + 1;
      }

      input.value = value;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
